'use client'

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import { User } from '@/lib/types'
import { BookOpenIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { ChatKitPageWrapper } from '../_components/chatkit-page-wrapper'
import { ChatKitLoginGate } from '../_components/chatkit-login-gate'
import { getChatKitConstants } from './_const'

interface IBlogGeneratorClientProps {
  user: User | null
  userApiKey: string
  hasApiKey: boolean
}

/**
 * Client component for Blog Generator
 * Handles ChatKit integration and user interactions
 */
export default function BlogGeneratorClient({
  user,
  userApiKey,
  hasApiKey,
}: IBlogGeneratorClientProps) {
  const t = useTranslations('blog-generator')
  const constants = getChatKitConstants(t)

  if (!user) {
    return (
      <ChatKitLoginGate
        icon={BookOpenIcon}
        title="Log in to generate blogs with AI"
        description="See real prompts, outlines, and drafts from the Blog Agent. Sign in to keep conversations, export drafts, and publish straight to your workspace."
        redirectUrl="/chatkit/blog-generator"
      />
    )
  }

  if (!hasApiKey) {
    return (
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <BookOpenIcon />
          </EmptyMedia>
          <EmptyTitle>No API Key</EmptyTitle>
          <EmptyDescription>
            Add an API key inside your workspace settings to unlock the Blog
            Agent.
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    )
  }

  return (
    <ChatKitPageWrapper
      user={user}
      userApiKey={userApiKey}
      workflowKey="blog"
      constants={constants}
      t={t}
      icon={BookOpenIcon}
    />
  )
}
